// src/context/CartContext.jsx
import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(function () {
    try {
      var saved = localStorage.getItem("circuit_cart");
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(function () {
    try {
      localStorage.setItem("circuit_cart", JSON.stringify(items));
    } catch {}
  }, [items]);

  // product: { id, name, category, imageUrl }
  // options: {
  //   selectedIds: [30, 4, 105, 93, ...],   ← array of selected option IDs for price API
  //   optionMap: { "Stock": "30", "size": "4", "qty": "105", ... }, ← for shipping + order API
  //   optionLabels: { "Stock": "14pt Cardstock", "size": "2x3.5", ... }, ← for display
  //   displayPrice: 40.45,   ← price after 35% markup (shown to customer)
  //   sinalitePrice: 29.95,  ← original Sinalite price (for records)
  // }
  function addItem(product, options) {
    var cartItem = {
      cartId: Date.now() + Math.random(),
      productId: product.id,
      productName: product.name,
      category: product.category || "",
      imageUrl: product.imageUrl || "",
      // Sinalite option data
      selectedIds: options.selectedIds || [],
      optionMap: options.optionMap || {},
      optionLabels: options.optionLabels || {},
      // Pricing
      displayPrice: options.displayPrice || 0,
      sinalitePrice: options.sinalitePrice || 0,
      description: options.description || "",
      // Artwork file (uploaded at checkout)
      artworkUrl: options.artworkUrl || null,
    };
    setItems(function (prev) {
      return [...prev, cartItem];
    });
  }

  function removeItem(cartId) {
    setItems(function (prev) {
      return prev.filter(function (i) {
        return i.cartId !== cartId;
      });
    });
  }

  // Update artwork URL for a cart item (set at checkout)
  function setArtworkUrl(cartId, url, name) {
    setItems(function (prev) {
      return prev.map(function (i) {
        return i.cartId === cartId ? { ...i, artworkUrl: url, artworkName: url ? (name || i.artworkName || "") : "" } : i;
      });
    });
  }

  function clearCart() {
    setItems([]);
  }

  var totalItems = items.length;
  var totalPrice = items.reduce(function (sum, i) {
    return sum + (i.displayPrice || 0);
  }, 0);

  return (
    <CartContext.Provider
      value={{
        items,
        addItem,
        removeItem,
        setArtworkUrl,
        clearCart,
        totalItems,
        totalPrice,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  var ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used inside CartProvider");
  return ctx;
}
